import service from './axios';
export const getOverview = (params = {}) => service.get('/manage/statistics/overview', { params });
export const getUserStats = (params = {}) => service.get('/manage/statistics/users', { params });
export const getOrderStats = (params = {}) => service.get('/manage/statistics/orders', { params });
export const getPetStats = (params = {}) => service.get('/manage/statistics/pets', { params });
export const getFavoriteStats = (params = {}) => service.get('/manage/statistics/favorites', { params });
export const getQuickLinks = () => service.get('/manage/quick-links');
export const saveQuickLinks = (paths) => service.put('/manage/quick-links', { paths });
